// Horrenmaker.nl — Lead Landing Copy (NL/DE).
// FACTS ONLY — verified from horrenmaker.nl + owner.
// No invented numbers, no fake names, no unverified guarantees.

export const translations = {
  nl: {
    nav: {
      werkwijze: 'Werkwijze',
      collectie: 'Collectie',
      kwaliteit: 'Kwaliteit',
      contact: 'Contact',
      cta: 'Offerte aanvragen',
    },
    hero: {
      mini: 'Over 30 jaar ervaring · Zonder boren mogelijk',
      title1: 'Laat de zomer binnen.',
      title2: 'Niet de insecten.',
      sub: 'Horren op maat voor ramen en deuren. Licht, strak en zonder gedoe.',
      ctaPrimary: 'Offerte aanvragen',
      ctaWhatsApp: 'Advies via WhatsApp',
      ctaPhone: 'Of bel direct',
      trustStrip: ['Zonder boren mogelijk', 'Gratis advies', 'Montage mogelijk', 'Door heel Nederland'],
      scrollHint: 'Voordeel-pakketten',
      scroll: 'Scroll',
    },
    problem: {
      eyebrow: 'Het probleem',
      title: 'Een raam open. En meteen heeft u gezelschap.',
      body: 'Muggen \u2019s nachts. Wespen bij het ontbijt. Pollen in het voorjaar. Een hor van Horrenmaker laat alleen lucht en licht binnen — al het andere blijft buiten.',
      ctaLabel: 'Vraag advies aan',
    },
    trustbar: [
      'Over 30 jaar ervaring',
      'Zonder boren mogelijk',
      'Millimeternauwkeurig maatwerk',
      'Gratis advies & opmeten',
      'Levering door heel Nederland',
      'Nederlandse kwaliteit',
    ],
    empathy: {
      eyebrow: 'Herkenbaar?',
      title: 'Het summen om 3 uur \u2019s nachts?',
      titleAfter: 'Voorbij.',
      body: '27 graden. Ramen dicht en zweten. Of ramen open en wakker liggen. Wij maken horren die u vergeet — tot het zomer wordt en u eindelijk weer kunt slapen.',
    },
    promise: {
      eyebrow: 'Zo voelt zomer écht',
      title: 'Open. Stil. Eindelijk.',
      body: 'Een hor die er niet is, tot u hem nodig hebt. Elk hor wordt millimeternauwkeurig gemaakt voor uw raam, deur of lichtschacht.',
    },
    products: {
      eyebrow: 'Voor elk raam, elke deur',
      title: 'Drie collecties, één belofte: maatwerk.',
      items: [
        {
          key: 'ramen',
          name: 'Ramen',
          badge: 'Bestseller',
          scene: 'Slaapkamerraam open. Stilte binnen.',
          desc: 'Spannhorren en klemhorren zonder boren. Draairaam-, plissé- en rolhorren — ook voor dakramen. Aluminium frame, RAL-kleuren, keuze in gaas.',
        },
        {
          key: 'deuren',
          name: 'Deuren',
          badge: 'Premium',
          scene: 'Loop ze open. Vergeet ze dicht.',
          desc: 'Draaihor, pendelhor, schuifdeur-hor en plissé deurhor. Robuust aluminium profiel, netjes sluitend, UV-bestendig gaas.',
        },
        {
          key: 'lichtschachten',
          name: 'Lichtschachten',
          badge: 'Maatwerk',
          scene: 'Nooit meer blad in de kelder.',
          desc: 'Stevig frame met duurzaam gaas. Bescherming tegen blad en vuil, regenbestendig, lichtdoorlatend. Op maat van uw lichtschacht.',
        },
      ],
    },
    lifestyle: {
      title: 'Onze horren bij u thuis.',
      sub: 'Op maat gemaakt, onzichtbaar geplaatst, jarenlang vergeten.',
      ctaLabel: 'Plan een gratis meting',
      hint: 'Levering ca. 15 werkdagen · 5 jaar garantie',
    },
    werkwijze: {
      eyebrow: 'Werkwijze',
      title: 'Vier stappen. Eenmalige inspanning.',
      note: 'Levering ca. 15 werkdagen na akkoord, afhankelijk van seizoen en type product.',
      steps: [
        { n: '01', t: 'Contact & advies', d: 'Vraag een offerte aan of stel uw vraag. Wij reageren snel met helder advies.' },
        { n: '02', t: 'Opmeten', d: 'Opmeten op afspraak of zelf met onze meetinstructie. Millimeternauwkeurig.' },
        { n: '03', t: 'Productie op maat', d: 'Uw hor wordt nauwkeurig gemaakt met hoogwaardige aluminium frames en gaas.' },
        { n: '04', t: 'Levering & montage', d: 'Levering aan huis (ca. 15 werkdagen). Montage op afspraak of eenvoudig zelf te plaatsen.' },
      ],
    },
    comparison: {
      eyebrow: 'Voor & Na',
      title: 'Bijna onzichtbaar. Verschuif de slider en zie zelf.',
      labelBefore: 'Zonder hor',
      labelAfter: 'Met Horrenmaker',
      sub: 'Zelfde raam. Zelfde licht. Het verschil zit in de details die je niet ziet — én in de muggen die binnen niet meer rondvliegen.',
      hint: 'Sleep om te vergelijken',
    },
    reviews: {
      eyebrow: 'Wat klanten zeggen',
      title: 'Kwaliteit waar u op kunt vertrouwen.',
      // Anonymous testimonials — verbatim from horrenmaker.nl
      items: [
        { name: 'Klant uit Arnhem', city: '', text: 'Uitstekende kwaliteit spannhorren. Zonder boren geplaatst en past perfect.' },
        { name: 'Klant uit Utrecht', city: '', text: 'Professionele opmeting en montage. De deurhor werkt perfect. Aanrader!' },
        { name: 'Klant uit Rotterdam', city: '', text: 'Lichtschacht afdekking op maat. Stevig en geen bladeren meer. Top service!' },
      ],
    },
    trust: {
      eyebrow: 'Nederlandse kwaliteit · Gemaakt in Arnhem',
      title: 'Over 30 jaar vakmanschap',
      titleAfter: 'in insectenwering.',
      body: 'Stevige aluminium frames en hoogwaardig gaas. Jarenlange bescherming tegen insecten, weer en wind. Elk hor wordt vakkundig op maat gemaakt.',
      badges: [
        { n: '30+', l: 'jaar ervaring' },
        { n: '100', l: '% maatwerk', suffix: '' },
        { n: '15', l: 'werkdagen levering' },
        { n: '0', l: 'boorgaten nodig' },
      ],
    },
    ctaBlock: {
      eyebrow: 'Vraag een vrijblijvende offerte aan',
      title: 'Deze zomer geen muggen meer.',
      sub: 'Vul drie velden in. Wij reageren snel.',
      success: 'Bedankt! We nemen snel contact met u op.',
      error: 'Er ging iets mis. Probeer het opnieuw of bel ons direct.',
      whatsappAlt: 'Of stuur ons direct een appje',
      avg: 'Wij verwerken uw gegevens vertrouwelijk conform de AVG. Geen tracking, geen cookies.',
    },
    config: {
      eyebrow: 'Liever zelf meten?',
      title: 'Meetinstructie & online bestellen.',
      cta: 'Open configurator',
      placeholder: 'Configurator wordt hier geladen',
    },
    faq: {
      eyebrow: 'Veelgestelde vragen',
      title: 'Alles wat u wilt weten.',
      // Verbatim from horrenmaker.nl FAQ
      items: [
        { q: 'Kan ik horren plaatsen zonder te boren?', a: 'Ja. Spannhorren en klemhorren kunnen zonder boren geplaatst worden. Ideaal als u kozijnen niet wilt beschadigen.' },
        { q: 'Hoe lang duurt de levertijd?', a: 'Levering ca. 15 werkdagen na akkoord, afhankelijk van seizoen en type product. Na akkoord plannen we productie en levering zo snel mogelijk.' },
        { q: 'Hoe nauwkeurig moet ik opmeten?', a: 'Millimeternauwkeurigheid is belangrijk. U kunt opmeting op afspraak kiezen of zelf meten met onze meetinstructie.' },
        { q: 'Welk gaas past het best bij mij?', a: 'Standaard insectengaas is het meest gekozen. Pollengaas helpt bij allergie, huisdiergaas is extra sterk. Wij adviseren u graag.' },
        { q: 'Monteren jullie ook?', a: 'Ja, montage is mogelijk op afspraak. U kunt ook zelf monteren met duidelijke instructies.' },
      ],
    },
    finalCta: {
      eyebrow: 'Begin hier',
      title: 'Klaar voor open ramen?',
      sub: 'Vraag vrijblijvend advies aan. Wij reageren snel.',
      primary: 'Offerte aanvragen',
      secondary: 'Bel ons direct',
      tertiary: 'WhatsApp',
    },
    contact: {
      eyebrow: 'Contact',
      title: 'Schrijf ons.',
      sub: 'Wij reageren snel.',
      name: 'Naam',
      email: 'E-mail',
      phone: 'Telefoon',
      message: 'Bericht',
      submit: 'Verstuur',
      submitting: 'Verzenden...',
    },
    footer: {
      tagline: 'Maatwerk horren. Over 30 jaar vakmanschap. Gemaakt in Arnhem.',
      navigation: 'Collectie',
      legal: 'Juridisch',
      impressum: 'Impressum',
      privacy: 'Privacy',
      terms: 'Voorwaarden',
      rights: 'Alle rechten voorbehouden.',
    },
    sticky: { call: 'Bel', whatsapp: 'WhatsApp', offer: 'Offerte' },

    uspBar: [
      'Gratis verzending door heel Nederland',
      'Eigen werkplaats — geen tussenpersonen',
      'Persoonlijk advies binnen 24 uur',
      'Maatwerk · 30+ jaar ervaring',
      'Zonder boren mogelijk — huurdersvriendelijk',
    ],

    benefits: {
      eyebrow: 'Waarom Horrenmaker',
      title: 'Vakwerk dat u dagelijks merkt — en jarenlang vergeet.',
      items: [
        { icon: 'hammer', title: 'Zonder boren mogelijk', sub: 'Veel systemen plaatsen we klemvast — huurdersvriendelijk en zonder schade.' },
        { icon: 'check',  title: 'Echt maatwerk',         sub: 'Elke hor wordt op uw kozijn gemaakt. Millimeternauwkeurig. Geen standaardmaten.' },
        { icon: 'award',  title: '30+ jaar ervaring',     sub: 'Sinds 1993 specialist in horren. We zijn er voor de lange termijn.' },
        { icon: 'shield', title: '5 jaar garantie',       sub: 'Op constructie en afwerking. Bij normaal gebruik gewoon vergeten in het kozijn.' },
        { icon: 'map',    title: 'Door heel Nederland',   sub: 'Advies, productie en levering — bij u thuis of online. Gratis verzending.' },
        { icon: 'phone',  title: 'Persoonlijk advies',    sub: 'Direct contact met de eigenaar. Geen callcenter, geen omwegen.' },
      ],
    },
    typeCompare: {
      eyebrow: 'Spannrahmen of draaihor?',
      title: 'Welke hor past bij úw raam?',
      sub: 'Twee bewezen oplossingen. Elk met een eigen sterke kant. Twijfelt u? Wij adviseren u eerlijk welk type bij uw woonsituatie past.',
      items: [
        {
          key: 'spann',
          name: 'Spannrahmen',
          tag: 'Vast op het kozijn',
          tagline: 'De onzichtbare klassieker.',
          desc: 'Een vaste hor die strak in het kozijn klemt. Volledig onzichtbaar van binnen, en blijft jarenlang op zijn plek staan zonder gedoe.',
          forWho: 'Ideaal voor ramen die u zelden hoeft te openen — slaapkamer, woonkamer, zolder. Voor allergie-vrije nachten en stille zomers.',
          pros: [
            'Plaatsing zonder boren mogelijk',
            'Volledig vlak met het kozijn',
            'Geen scharnier — minder slijtage',
            'Direct uit het raam te tillen voor reiniging',
          ],
          cons: [
            'Niet praktisch als u dagelijks door het raam wilt',
          ],
          badge: 'Bestseller',
          image: '/scenes/steps/step-1-meten.png',
        },
        {
          key: 'draai',
          name: 'Draaihor',
          tag: 'Met scharnier — opent als een raam',
          tagline: 'De praktische oplossing.',
          desc: 'Een hor met scharnieren die u opent als een echt raam. Blijft altijd op zijn plek, en u loopt door zonder de hor uit het kozijn te tillen.',
          forWho: 'Perfect voor keukenramen, balkondeuren of plekken waar u dagelijks bij wilt — bijvoorbeeld om de planten op de vensterbank water te geven.',
          pros: [
            'Open swing-systeem — altijd toegankelijk',
            'Sluit vanzelf — geen muggen bij open raam',
            'Robuust aluminium frame met magneetafsluiting',
            'Geschikt voor zware dagelijkse belasting',
          ],
          cons: [
            'Iets duurder dan een spannhor',
          ],
          badge: 'Voor dagelijks gebruik',
          image: '/scenes/steps/step-2-maken.png',
        },
      ],
      ctaLabel: 'Welke past bij mij? Vraag advies',
      ctaHint: 'Onze adviseur helpt u in 5 minuten kiezen.',
    },
    bigQuote: {
      eyebrow: 'Eén klant',
      quote: 'Wij hebben er drie zomers geen mug meer in huis gehad. Hadden we maar veel eerder gedaan.',
      author: 'Familie de Vries',
      role: 'Klant uit Utrecht',
    },
    about: {
      eyebrow: 'Over Horrenmaker',
      title: 'Eén familie. Eén ambacht. Drie generaties horren.',
      paragraphs: [
        'Horrenmaker.nl is geen webshop met massaproductie. Wij meten, snijden en monteren elke hor zelf — vanuit onze werkplaats in Nederland, sinds 1993.',
        'Wat begon als familiebedrijf is gegroeid tot dé specialist in maatwerk insectenscherming voor heel Nederland. Wat hetzelfde bleef: persoonlijk contact, eerlijk advies en de overtuiging dat een goede hor minstens 15 jaar moet meegaan.',
      ],
      stats: [
        { n: '30+', l: 'jaar ervaring' },
        { n: '100', l: '% maatwerk' },
        { n: '15',  l: 'werkdagen levering' },
      ],
      ctaLabel: 'Lees meer over ons',
    },
    sample: {
      eyebrow: 'Gratis & vrijblijvend',
      title: 'Twijfelt u nog? Vraag eerst een gratis adviesgesprek aan.',
      body: 'In 15 minuten bespreken we uw raam, uw woning en uw wensen. U krijgt direct duidelijkheid — geen aankoopdruk, geen verkooppraat.',
      ctaPrimary: 'Plan een gratis gesprek',
      ctaSecondary: 'Stel uw vraag via WhatsApp',
    },
    sampleKit: {
      eyebrow: 'Gratis stalenpakket',
      title: 'Liever eerst voelen? Vraag gratis stalen aan.',
      body: 'We sturen u kosteloos een pakketje met stoffen, gaas en aluminiumkleuren. Zo voelt u de kwaliteit voordat u beslist — gratis verzonden naar heel Nederland.',
      items: [
        '3 gaastypes (standaard · pollen · huisdier)',
        '4 RAL-kleurstalen aluminium',
        'Korte meet-instructie',
        'Geen verzendkosten · geen verplichting',
      ],
      fields: { name: 'Naam', email: 'E-mail', address: 'Adres (straat, nr, postcode, plaats)' },
      submitLabel: 'Stuur mij gratis stalen',
      success: 'Bedankt! Het pakketje is onderweg.',
      error: 'Er ging iets mis. Probeer het opnieuw of stuur ons een appje.',
    },
    advisor: {
      name: 'Marco',
      role: 'Persoonlijk advies',
      ctaLabel: 'Stel je vraag',
      waMessage: 'Hallo Marco, ik heb een korte vraag over horren.',
    },
  },

  de: {
    nav: {
      werkwijze: 'Ablauf',
      collectie: 'Kollektion',
      kwaliteit: 'Qualität',
      contact: 'Kontakt',
      cta: 'Angebot anfragen',
    },
    hero: {
      mini: 'Über 30 Jahre Erfahrung · Ohne Bohren möglich',
      title1: 'Lass den Sommer rein.',
      title2: 'Nicht die Insekten.',
      sub: 'Insektenschutz nach Maß für Fenster und Türen. Hell, schlicht und ohne Aufwand.',
      ctaPrimary: 'Angebot anfragen',
      ctaWhatsApp: 'Beratung via WhatsApp',
      ctaPhone: 'Oder ruf an',
      trustStrip: ['Ohne Bohren möglich', 'Kostenlose Beratung', 'Montage möglich', 'In den gesamten Niederlanden'],
      scrollHint: 'Spar-Bundles',
      scroll: 'Scroll',
    },
    problem: {
      eyebrow: 'Das Problem',
      title: 'Ein Fenster auf. Schon ist jemand mitgekommen.',
      body: 'Mücken nachts. Wespen beim Frühstück. Pollen im Frühling. Ein Horrenmaker-Insektenschutz lässt nur Luft und Licht rein — alles andere bleibt draußen.',
      ctaLabel: 'Beratung anfragen',
    },
    trustbar: [
      'Über 30 Jahre Erfahrung',
      'Ohne Bohren möglich',
      'Millimetergenaue Maßarbeit',
      'Kostenlose Beratung & Aufmaß',
      'Lieferung in den Niederlanden',
      'Niederländische Qualität',
    ],
    empathy: {
      eyebrow: 'Kennst du das?',
      title: 'Das Summen um 3 Uhr nachts?',
      titleAfter: 'Vorbei.',
      body: '27 Grad. Fenster zu und schwitzen. Oder Fenster auf und nicht schlafen. Wir bauen Insektenschutz, den du vergisst — bis es Sommer wird und du endlich wieder schlafen kannst.',
    },
    promise: {
      eyebrow: 'So fühlt sich Sommer wirklich an',
      title: 'Offen. Still. Endlich.',
      body: 'Ein Insektenschutz, der nicht da ist, bis du ihn brauchst. Jeder Schutz wird millimetergenau für dein Fenster, deine Tür oder deinen Lichtschacht gefertigt.',
    },
    products: {
      eyebrow: 'Für jedes Fenster, jede Tür',
      title: 'Drei Kollektionen, ein Versprechen: Maßarbeit.',
      items: [
        {
          key: 'ramen',
          name: 'Fenster',
          badge: 'Bestseller',
          scene: 'Schlafzimmerfenster offen. Stille drinnen.',
          desc: 'Spann- und Klemmrahmen ohne Bohren. Dreh-, Plissee- und Rollos — auch für Dachfenster. Aluminiumrahmen, RAL-Farben, Auswahl an Gewebe.',
        },
        {
          key: 'deuren',
          name: 'Türen',
          badge: 'Premium',
          scene: 'Geh hindurch. Vergiss, dass sie da ist.',
          desc: 'Dreh-, Pendel-, Schiebe- und Plissee-Türen. Robustes Aluminiumprofil, sauber schließend, UV-beständiges Gewebe.',
        },
        {
          key: 'lichtschachten',
          name: 'Lichtschächte',
          badge: 'Maßarbeit',
          scene: 'Nie wieder Laub im Keller.',
          desc: 'Stabiler Rahmen mit langlebigem Gewebe. Schutz vor Laub und Schmutz, regenbeständig, lichtdurchlässig. Nach Maß für deinen Lichtschacht.',
        },
      ],
    },
    lifestyle: {
      title: 'Unser Insektenschutz bei dir zuhause.',
      sub: 'Nach Maß gefertigt, unsichtbar montiert, jahrelang vergessen.',
      ctaLabel: 'Kostenfreies Aufmaß planen',
      hint: 'Lieferung ca. 15 Arbeitstage · 5 Jahre Garantie',
    },
    werkwijze: {
      eyebrow: 'Ablauf',
      title: 'Vier Schritte. Einmaliger Aufwand.',
      note: 'Lieferung ca. 15 Arbeitstage nach Auftragsbestätigung, abhängig von Saison und Produkttyp.',
      steps: [
        { n: '01', t: 'Kontakt & Beratung', d: 'Fordere ein Angebot an oder stelle deine Frage. Wir antworten schnell mit klarer Beratung.' },
        { n: '02', t: 'Aufmaß', d: 'Aufmaß nach Termin oder selbst mit unserer Messanleitung. Millimetergenau.' },
        { n: '03', t: 'Maßanfertigung', d: 'Dein Schutz wird sorgfältig aus hochwertigen Aluminiumprofilen und Gewebe gefertigt.' },
        { n: '04', t: 'Lieferung & Montage', d: 'Lieferung nach Hause (ca. 15 Arbeitstage). Montage nach Termin oder einfach selbst einsetzen.' },
      ],
    },
    comparison: {
      eyebrow: 'Vorher & Nachher',
      title: 'Fast unsichtbar. Schieb den Regler und sieh selbst.',
      labelBefore: 'Ohne Insektenschutz',
      labelAfter: 'Mit Horrenmaker',
      sub: 'Gleiches Fenster. Gleiches Licht. Der Unterschied liegt im Detail, das man nicht sieht — und in den Mücken, die nicht mehr drin sind.',
      hint: 'Ziehe zum Vergleichen',
    },
    reviews: {
      eyebrow: 'Was Kunden sagen',
      title: 'Qualität, der man vertrauen kann.',
      items: [
        { name: 'Kunde aus Arnheim', city: '', text: 'Hervorragende Qualität der Spannrahmen. Ohne Bohren montiert und passt perfekt.' },
        { name: 'Kunde aus Utrecht', city: '', text: 'Professionelles Aufmaß und Montage. Die Türsicherung funktioniert perfekt. Empfehlenswert!' },
        { name: 'Kunde aus Rotterdam', city: '', text: 'Lichtschachtabdeckung nach Maß. Stabil und kein Laub mehr. Top Service!' },
      ],
    },
    trust: {
      eyebrow: 'Niederländische Qualität · Gefertigt in Arnhem',
      title: 'Über 30 Jahre Handwerk',
      titleAfter: 'im Insektenschutz.',
      body: 'Stabile Aluminiumrahmen und hochwertiges Gewebe. Jahrelanger Schutz vor Insekten, Wind und Wetter. Jeder Schutz wird fachmännisch nach Maß gefertigt.',
      badges: [
        { n: '30+', l: 'Jahre Erfahrung' },
        { n: '100', l: '% Maßarbeit' },
        { n: '15', l: 'Arbeitstage Lieferung' },
        { n: '0', l: 'Bohrlöcher nötig' },
      ],
    },
    ctaBlock: {
      eyebrow: 'Unverbindliches Angebot anfragen',
      title: 'Diesen Sommer keine Mücken mehr.',
      sub: 'Drei Felder ausfüllen. Wir antworten schnell.',
      success: 'Danke! Wir melden uns schnell bei dir.',
      error: 'Etwas ist schiefgelaufen. Bitte erneut versuchen oder direkt anrufen.',
      whatsappAlt: 'Oder schreib uns direkt auf WhatsApp',
      avg: 'Wir verarbeiten deine Daten vertraulich nach DSGVO. Kein Tracking, keine Cookies.',
    },
    config: {
      eyebrow: 'Lieber selbst messen?',
      title: 'Messanleitung & online bestellen.',
      cta: 'Konfigurator öffnen',
      placeholder: 'Konfigurator wird hier geladen',
    },
    faq: {
      eyebrow: 'Häufige Fragen',
      title: 'Alles, was du wissen willst.',
      items: [
        { q: 'Kann der Insektenschutz ohne Bohren montiert werden?', a: 'Ja. Spann- und Klemmrahmen werden ohne Bohren montiert. Ideal, wenn du deine Rahmen nicht beschädigen möchtest.' },
        { q: 'Wie lange dauert die Lieferung?', a: 'Lieferung ca. 15 Arbeitstage nach Auftragsbestätigung, abhängig von Saison und Produkttyp. Nach Bestätigung planen wir Produktion und Lieferung schnellstmöglich.' },
        { q: 'Wie genau muss ich messen?', a: 'Millimetergenauigkeit ist wichtig. Du kannst Aufmaß nach Termin wählen oder selbst messen mit unserer Messanleitung.' },
        { q: 'Welches Gewebe passt am besten zu mir?', a: 'Standard-Insektengewebe wird am häufigsten gewählt. Pollengewebe hilft bei Allergie, Haustiergewebe ist extra stabil. Wir beraten dich gerne.' },
        { q: 'Montiert ihr auch?', a: 'Ja, Montage ist nach Termin möglich. Du kannst auch selbst montieren mit klaren Anleitungen.' },
      ],
    },
    finalCta: {
      eyebrow: 'Hier beginnen',
      title: 'Bereit für offene Fenster?',
      sub: 'Unverbindliche Beratung. Wir antworten schnell.',
      primary: 'Angebot anfragen',
      secondary: 'Jetzt anrufen',
      tertiary: 'WhatsApp',
    },
    contact: {
      eyebrow: 'Kontakt',
      title: 'Schreib uns.',
      sub: 'Wir antworten schnell.',
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      message: 'Nachricht',
      submit: 'Senden',
      submitting: 'Wird gesendet...',
    },
    footer: {
      tagline: 'Maßgefertigter Insektenschutz. Über 30 Jahre Handwerk. Gefertigt in Arnhem.',
      navigation: 'Kollektion',
      legal: 'Rechtliches',
      impressum: 'Impressum',
      privacy: 'Datenschutz',
      terms: 'AGB',
      rights: 'Alle Rechte vorbehalten.',
    },
    sticky: { call: 'Anrufen', whatsapp: 'WhatsApp', offer: 'Angebot' },

    uspBar: [
      'Kostenloser Versand in den gesamten Niederlanden',
      'Eigene Werkstatt — keine Zwischenhändler',
      'Persönliche Beratung binnen 24 Stunden',
      'Maßwerk · 30+ Jahre Erfahrung',
      'Ohne Bohren möglich — mieterfreundlich',
    ],

    benefits: {
      eyebrow: 'Warum Horrenmaker',
      title: 'Handwerk, das du täglich merkst — und jahrelang vergisst.',
      items: [
        { icon: 'hammer', title: 'Ohne Bohren möglich', sub: 'Viele Systeme montieren wir klemmend — mieterfreundlich und ohne Schäden.' },
        { icon: 'check',  title: 'Echtes Maßwerk',      sub: 'Jeder Insektenschutz wird auf deinen Rahmen gefertigt. Millimetergenau.' },
        { icon: 'award',  title: '30+ Jahre Erfahrung', sub: 'Seit 1993 Spezialist für Insektenschutz. Langfristig für dich da.' },
        { icon: 'shield', title: '5 Jahre Garantie',    sub: 'Auf Konstruktion und Verarbeitung. Bei normaler Nutzung einfach vergessen.' },
        { icon: 'map',    title: 'Niederlandeweit',     sub: 'Beratung, Produktion und Lieferung — auch bei dir zuhause. Versand gratis.' },
        { icon: 'phone',  title: 'Persönliche Beratung',sub: 'Direkter Kontakt mit dem Inhaber. Kein Callcenter, keine Umwege.' },
      ],
    },
    typeCompare: {
      eyebrow: 'Spannrahmen oder Drehfenster?',
      title: 'Welcher Insektenschutz passt zu deinem Fenster?',
      sub: 'Zwei bewährte Lösungen — jede mit ihrer eigenen Stärke. Unsicher? Wir beraten dich ehrlich, welcher Typ am besten zu deiner Wohnsituation passt.',
      items: [
        {
          key: 'spann',
          name: 'Spannrahmen',
          tag: 'Fest im Rahmen',
          tagline: 'Der unsichtbare Klassiker.',
          desc: 'Ein fester Rahmen, der sich straff in den Fensterrahmen klemmt. Von innen praktisch unsichtbar und bleibt jahrelang an seinem Platz — ohne Aufwand.',
          forWho: 'Ideal für Fenster, die du selten öffnest — Schlafzimmer, Wohnzimmer, Dachgeschoss. Für allergiefreie Nächte und stille Sommer.',
          pros: [
            'Montage ohne Bohren möglich',
            'Bündig mit dem Rahmen — fast unsichtbar',
            'Keine Scharniere — weniger Verschleiß',
            'Lässt sich zum Reinigen einfach entnehmen',
          ],
          cons: [
            'Weniger praktisch, wenn du täglich durchs Fenster greifst',
          ],
          badge: 'Bestseller',
          image: '/scenes/steps/step-1-meten.png',
        },
        {
          key: 'draai',
          name: 'Drehfenster',
          tag: 'Mit Scharnier — öffnet wie ein Fenster',
          tagline: 'Die praktische Lösung.',
          desc: 'Ein Insektenschutz mit Scharnieren, den du wie ein echtes Fenster öffnest. Bleibt immer am Platz — du musst ihn nicht jedesmal herausnehmen.',
          forWho: 'Perfekt für Küchenfenster, Balkontüren oder Stellen, an die du täglich heran möchtest — zum Beispiel um die Blumen auf der Fensterbank zu gießen.',
          pros: [
            'Öffnet wie ein Fenster — täglicher Zugang',
            'Schließt selbstständig — keine Mücken bei offenem Fenster',
            'Robustes Aluminiumprofil mit Magnetverschluss',
            'Für hohe tägliche Beanspruchung gemacht',
          ],
          cons: [
            'Etwas teurer als der Spannrahmen',
          ],
          badge: 'Für täglichen Gebrauch',
          image: '/scenes/steps/step-2-maken.png',
        },
      ],
      ctaLabel: 'Welcher passt zu mir? Beratung anfragen',
      ctaHint: 'Unser Berater hilft dir in 5 Minuten bei der Wahl.',
    },
    bigQuote: {
      eyebrow: 'Eine Kundin',
      quote: 'Drei Sommer lang keine einzige Mücke mehr im Haus. Hätten wir früher machen sollen.',
      author: 'Familie de Vries',
      role: 'Kunden aus Utrecht',
    },
    about: {
      eyebrow: 'Über Horrenmaker',
      title: 'Eine Familie. Ein Handwerk. Drei Generationen Insektenschutz.',
      paragraphs: [
        'Horrenmaker.nl ist kein Webshop mit Massenproduktion. Wir messen, schneiden und montieren jeden Insektenschutz selbst — aus unserer Werkstatt in den Niederlanden, seit 1993.',
        'Was als Familienunternehmen begann, ist der Spezialist für maßgefertigten Insektenschutz in den gesamten Niederlanden geworden. Was gleich blieb: persönlicher Kontakt, ehrliche Beratung und die Überzeugung, dass ein guter Insektenschutz mindestens 15 Jahre halten muss.',
      ],
      stats: [
        { n: '30+', l: 'Jahre Erfahrung' },
        { n: '100', l: '% Maßwerk' },
        { n: '15',  l: 'Werktage Lieferung' },
      ],
      ctaLabel: 'Mehr über uns',
    },
    sample: {
      eyebrow: 'Kostenlos & unverbindlich',
      title: 'Noch unsicher? Erst ein kostenloses Beratungsgespräch.',
      body: 'In 15 Minuten besprechen wir dein Fenster, deine Wohnung und deine Wünsche. Du bekommst sofort Klarheit — kein Verkaufsdruck, keine Vertriebsfloskeln.',
      ctaPrimary: 'Kostenloses Gespräch buchen',
      ctaSecondary: 'Frag via WhatsApp',
    },
    sampleKit: {
      eyebrow: 'Gratis Musterpaket',
      title: 'Lieber erst anfassen? Fordere kostenlose Muster an.',
      body: 'Wir schicken dir ein Päckchen mit Geweben, Aluminiumfarben und einer kurzen Messanleitung — kostenfrei in die Niederlande und nach Deutschland.',
      items: [
        '3 Gewebearten (Standard · Pollen · Haustier)',
        '4 RAL-Aluminium-Farbproben',
        'Kurze Messanleitung',
        'Versandkostenfrei · keine Verpflichtung',
      ],
      fields: { name: 'Name', email: 'E-Mail', address: 'Adresse (Straße, Nr, PLZ, Ort)' },
      submitLabel: 'Schick mir kostenlose Muster',
      success: 'Danke! Das Päckchen ist unterwegs.',
      error: 'Etwas ist schiefgelaufen. Versuche es erneut oder schreib uns auf WhatsApp.',
    },
    advisor: {
      name: 'Marco',
      role: 'Persönliche Beratung',
      ctaLabel: 'Frag uns',
      waMessage: 'Hallo Marco, ich habe eine kurze Frage zum Insektenschutz.',
    },
  },
};

export const company = {
  name: 'fliro.tech B.V.',
  brand: 'Horrenmaker.nl',
  street: 'Veldoven 6',
  postal: '6826 TT',
  city: 'Arnhem',
  country: 'Niederlande',
  ceo: 'Gerhard Roß',
  email: 'info@horrenmaker.nl',
  emailLegal: 'info@fliro.tech',
  kvk: '42004418',
  phoneDE: '+49 175 59 56 437',
  phoneNL: '+31 6 51 969 643',
  whatsapp: '4917559564437',
  odr: 'https://ec.europa.eu/consumers/odr',
  hours: {
    nl: { weekdays: 'Ma – Vr  08:00 – 17:30', saturday: 'Za  09:00 – 14:00', sunday: 'Zo  Gesloten' },
    de: { weekdays: 'Mo – Fr  08:00 – 17:30', saturday: 'Sa  09:00 – 14:00', sunday: 'So  Geschlossen' },
  },
};

const HM = '/products/';
export const media = {
  hero: '/scenes/hero-summer.webp',
  heroFallback: HM + 'horrenmaker-spannrahmen.webp',
  product_ramen: HM + 'horrenmaker-drehfenster.webp',
  product_deuren: HM + 'horrenmaker-drehtuer.webp',
  product_lichtschachten: HM + 'horrenmaker-lichtschachtabdeckung.webp',
  comparisonA: '/scenes/compare-before.jpg',
  comparisonB: '/scenes/compare-after.jpg',
  cta: HM + 'horrenmaker-schiebetuer.webp',
  inspiration: [
    HM + 'horrenmaker-drehfenster.webp',
    HM + 'horrenmaker-plissee-fenster.webp',
    HM + 'horrenmaker-rollo-fenster.webp',
    HM + 'horrenmaker-dachfenster-rollo.webp',
    HM + 'horrenmaker-pendeltuer.webp',
    HM + 'horrenmaker-plisseetuer.webp',
  ],
  empathy: '/scenes/empathy-night.png',
  atelier: '/medienpool/beratung-zu-massgeschneiderten-fliegengi-87a17660.webp',
  promise: '/medienpool/horrenmaker-fliegengittermacher-beratung.webp',
};
